import React, { FC } from 'react';
import background from './img/trialBackground.jpg';
import wrapper from './img/trialWrapper.png';
import classNames from 'classnames';
import * as S from './styled';

interface Props {
	className?: string;
	number?: number;
	title?: string;
}

export const TrialBlock: FC<Props> = props => {
	const { number = 7, title = '7-day free trial', className } = props;
	return (
		<S.Container style={{ backgroundImage: `url(${background})` }}>
			<S.NumberWrapper style={{ backgroundImage: `url(${wrapper})` }}>{number}</S.NumberWrapper>
			<S.Title>{title}</S.Title>
		</S.Container>
	);
};
